import { useState } from 'react'
import styled from 'styled-components'

import * as themeUtilities from '@/utilities/client-components/utilities/themeUtils'

interface FallbackImageProps {
  className?: string
}

const FallbackImage = ({ className }: FallbackImageProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24">
    <path
      d="M23,2H1A1,1,0,0,0,0,3V21a1,1,0,0,0,1,1H23a1,1,0,0,0,1-1V3A1,1,0,0,0,23,2ZM22,4V14.3L17.759,9.35A1,1,0,0,0,17.005,9a.879.879,0,0,0-.757.342l-6.3,7.195L6.707,13.293A.988.988,0,0,0,5.955,13a1,1,0,0,0-.723.358L2,17.238V4Z"
      fill="currentColor"
    />
    <circle fill="currentColor" cx="9" cy="8" r="2" />
  </svg>
)

const StyledFallbackImage = styled.img`
  color: ${({ theme }: any) => themeUtilities.getColor(theme, 'default', 'light')};
`

interface ImageWithFallbackProps {
  alt?: string
  className?: string
  onError?(...args: unknown[]): unknown
  src: string
}

const ImageWithFallback = ({ onError, className, src, alt }: ImageWithFallbackProps) => {
  const [imageError, setImageError] = useState(false)

  const imageLoadError = (e: any) => {
    if (!imageError) {
      setImageError(true)
      // Also always show it as non-rounded
      e.target.style.borderRadius = 0

      // @ts-expect-error
      onError()
    }
  }

  return (
    <StyledFallbackImage
      className={className}
      alt={alt}
      src={src}
      onError={imageLoadError}
      as={imageError ? FallbackImage : 'img'}
    />
  )
}

ImageWithFallback.displayName = 'ImageWithFallback'

ImageWithFallback.defaultProps = {
  onError: () => {}
}

export default ImageWithFallback
